import { useState } from "react"
import { ArrowRightLeft } from "lucide-react"
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogDescription,
  DialogFooter,
} from "@/components/ui/dialog"
import { Button } from "@/components/ui/button"

interface StatusOption {
  value: string
  label: string
}

interface BulkStatusDialogProps {
  open: boolean
  onOpenChange: (open: boolean) => void
  count: number
  options: StatusOption[]
  onConfirm: (value: string) => Promise<void>
  title?: string
  fieldLabel?: string
}

export function BulkStatusDialog({
  open,
  onOpenChange,
  count,
  options,
  onConfirm,
  title = "Zmien status",
  fieldLabel = "Status",
}: BulkStatusDialogProps) {
  const [selectedValue, setSelectedValue] = useState("")
  const [isSubmitting, setIsSubmitting] = useState(false)

  const handleConfirm = async () => {
    if (!selectedValue) return
    setIsSubmitting(true)
    try {
      await onConfirm(selectedValue)
      onOpenChange(false)
      setSelectedValue("")
    } finally {
      setIsSubmitting(false)
    }
  }

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent>
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2">
            <ArrowRightLeft size={20} className="text-primary" />
            {title} - masowa zmiana
          </DialogTitle>
          <DialogDescription>
            Zmien {fieldLabel.toLowerCase()} dla {count}{" "}
            {count === 1 ? "elementu" : "elementow"}.
          </DialogDescription>
        </DialogHeader>
        <div className="py-4">
          <label className="text-sm font-medium text-foreground mb-2 block">
            Wybierz {fieldLabel.toLowerCase()}
          </label>
          <select
            value={selectedValue}
            onChange={(e) => setSelectedValue(e.target.value)}
            className="h-9 w-full rounded-lg border border-input bg-transparent px-3 text-sm text-foreground"
          >
            <option value="">-- Wybierz --</option>
            {options.map((opt) => (
              <option key={opt.value} value={opt.value}>
                {opt.label}
              </option>
            ))}
          </select>
        </div>
        <DialogFooter>
          <Button
            variant="outline"
            onClick={() => onOpenChange(false)}
            disabled={isSubmitting}
          >
            Anuluj
          </Button>
          <Button
            onClick={handleConfirm}
            disabled={isSubmitting || !selectedValue}
          >
            {isSubmitting ? "Zapisywanie..." : "Zastosuj"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  )
}
